//
// 'ellipsizeTextService'
// by: J D
// created: 2016 09 14
//
// Note:
//   *** THIS IS NOT THE FINAL VERSION ***
//  this is done to give more time testing and resolving this issue
//    of showing a multilined text, 'cleaning up' excess text from a container, 
//    and representing the excess with an ellipsis.
//  this is a 'service' triggered like a 'filter'.
//  this is done to time the rendering of the text in the container,
//    thus printing out the data the method needs to run 'ellipsize' the text.
//  this only targets the desktop/tablet 'sidebar', not including the mobile counterpart.
//

angular.module('storyApp')
.filter('ellipsizeTextService', [ function($document) {
  return function (input) {

    // apply ellipsis on the element
    function applyEllipsis(elem) {
      // split the words in an array
      var wordArray = elem.innerHTML.split(' ');          
      // loop checks if the content is taller than the container
      while(elem.scrollHeight > elem.offsetHeight) {          
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
        // 'pop' out the last item of the word array and add the '...' at the end.
        wordArray.pop();
        elem.innerHTML = wordArray.join(' ') + '&hellip;';
        // NOTE: 'elem.innerHTML' is always prints a next text until the loop stops.
        // this is to make sure the loop will be able to recalculate precisely.
      }      
    }

    // check the target container for a classname flag.
    // this is done to cut down on excessive checks and re-running the block more than it should. 
    if (!document.getElementById('sidebar').classList.contains('ellipsized')) {
      
      // check the target container's content for a specified set of tags.
      // this is to make sure the modification is only done on the targeted elements
      if (document.querySelectorAll('#sidebar .three-things-thumbnail .thumbnail-headline').length > 0) {
        var items = document.querySelectorAll('#sidebar .three-things-thumbnail .thumbnail-headline');

        for(var i=0,l=items.length;i<l;i++) {

          applyEllipsis(items[i]);
        }

        document.getElementById('sidebar').classList.add('ellipsized');
      }
    }

    // for the main atricle thumbnail headline on the side bar
    if (!document.getElementById('main-story-thumbnail').classList.contains('ellipsized')) {
      var item = document.querySelector('#main-story-thumbnail .thumbnail-headline');

      if (item.scrollHeight > item.offsetHeight) {

        applyEllipsis(item);

        document.getElementById('main-story-thumbnail').classList.add('ellipsized');
      }
    }


    return input;
  };
}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/ellipsizeTextService.js